import { createApp } from "vue";
import { createPinia } from "pinia";
import AppMain from "./AppMain.vue";
import Router from "@/router";
import store from "@/store";
import toastr from "toastr";
import axios from "axios";
import VueAxios from "vue-axios";
import "./assets/tailwind.css";
import piniaPersist from "pinia-plugin-persistedstate";

import "vue-select/dist/vue-select.css";
import ViewUIPlus from "view-ui-plus";
import "view-ui-plus/dist/styles/viewuiplus.css";
import vSelect from "vue-select";

// import "vue-select/dist/vue-select.css";
axios.defaults.withCredentials = true;
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('user')}`

// const app = createApp({});
// // app.component(Home_main)
// app.mount("#app")
const pinia = createPinia();

const app = createApp(AppMain);
pinia.use(piniaPersist);
app.component("v-select", vSelect);
app.use(ViewUIPlus);
app.use(VueAxios, axios);
app.use(Router);
app.use(toastr);
app.use(store);
app.use(pinia);
app.use(vSelect);

app.mount("#app");
